import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import * as actions from '../../actions'
import { FORM_EGRESO_CALADO } from '../../../../config/forms'
import GrillaCallesDeCaladoEgreso from '../../components/GrillaCallesDeCaladoEgreso'
import { Button, Badge } from 'react-bootstrap'
import { ToastContainer } from 'react-toastify'
import StatusModal from '../../../Forms/SharedComponents/containers/StatusModal'

function EgresoCalado (props) {
  const { ceaCallesCaladoEgreso, getCamionesCallesDeCaladoEgreso } = props

  useEffect(() => {
    getCamionesCallesDeCaladoEgreso()
  }, [getCamionesCallesDeCaladoEgreso])

  const onSelectionChange = (selections) => {
    props.cargarCalleDeCaladoEgreso(selections)
  }

  const handleEgreso = () => {
    props.egreso()
  }

  const hideStatus = () => {
    props.hideCeaCaladoEgresoProcesados()
    props.getCallesDeCalado()
  }

  const renderAcciones = () => {
    const { egresosSeleccionados, ceaCallesCaladoEgreso } = props
    const disabled = egresosSeleccionados.length === 0

    return (
      <div className='botones-acciones-egreso-calado'>
        <Button
          variant='success'
          onClick={handleEgreso}
          disabled={disabled}
          size='lg'
        >
          Egreso
        </Button>
        <div>
          <h2>
            <Badge variant='light'>Total: {(ceaCallesCaladoEgreso.length) ? ceaCallesCaladoEgreso.length : 0}</Badge>
            <Badge variant='light'>Seleccionados: {(egresosSeleccionados.length) ? egresosSeleccionados.length : 0}</Badge>
          </h2>
        </div>
      </div>
    )
  }

  const show = (props.ceaCaladoEgresoProcesados > 0 || props.errorCeaCaladoEgresoProcesados)

  const rol = props.roles.filter(roles => roles === 'SUPERVISOR' || roles === 'SUPMANTENIMIENTO' || roles === 'DESARROLLADOR')
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR')

  return (
    <div className='calado-egreso'>
      <StatusModal
        show={show}
        onClick={hideStatus}
        message={`Cargas egresadas ${props.ceaCaladoEgresoProcesados}`}
        errorMessage={props.errorCeaCaladoEgresoProcesados}
      />
      <ToastContainer />
      <h2>Cargas en calles de calado</h2>
      { props.requestingCamionesCallesCalado
        ? <span>Consultando...</span>
        : <>
          { rolAutorizado && <div> { renderAcciones() } </div> }
          <br />
          <GrillaCallesDeCaladoEgreso
            rows={ceaCallesCaladoEgreso}
            egresosSeleccionados={props.egresosSeleccionados}
            onSelectionChange={onSelectionChange}
          />
        </>
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    requestingCamionesCallesCalado: state.calado.requestingCamionesCallesCalado,
    ceaCallesCaladoEgreso: state.calado.ceaCallesCaladoEgreso,
    egresosSeleccionados: state.calado.egresosSeleccionados,
    ceaCaladoEgresoProcesados: state.calado.ceaCaladoEgresoProcesados,
    errorceaCaladoEgresoProcesados: state.calado.errorceaCaladoEgresoProcesados,
    roles: state.auth.roles
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({
    form: FORM_EGRESO_CALADO
  })(EgresoCalado)
)
